var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNews = function SvgNews(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 30 30"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M20 7.5h3.75A1.25 1.25 0 0 1 25 8.75V22.5a2.5 2.5 0 0 1-2.5 2.5m0 0a2.5 2.5 0 0 1-2.5-2.5V6.25A1.25 1.25 0 0 0 18.75 5H6.25A1.25 1.25 0 0 0 5 6.25v15A3.75 3.75 0 0 0 8.75 25zM10 10h5m-5 5h5m-5 5h5"
  })));
};
export default SvgNews;